import React from 'react';
import styled from 'styled-components';
import LightningIcon from '../../assets/svgs/lightning.svg';
import colours from '../../theme/colours';
import PropTypes from 'prop-types';
import fonts from '../../theme/fonts';

const Tag = ({ color, children, ...props }) => {
  return (
    <TagContainer color={color} data-role="presentation" {...props}>
      <TagIcon data-testid="icon">
        <LightningIcon />
      </TagIcon>
      <TagText data-testid="text">{children}</TagText>
    </TagContainer>
  );
};

const TagIcon = styled.span`
  display: inline-block;
  height: 16px;
  margin-right: 4px;
`;

const TagText = styled.span`
  display: inline-block;
  font-size: 12px;
  font-family: ${fonts.secondary};
  line-height: 16px;
  padding-right: 4px;
  color: ${colours.grey_900};
  white-space: nowrap;
`;

const TagContainer = styled.span`
  display: inline-flex;
  height: 24px;
  padding: 4px;
  border-radius: 4px;
  background-color: ${p => p.color};
  justify-content: center;
`;

export const Tags = styled.div`
  display: inline-flex;
`;

export const TagColors = {
  grey: colours.grey_50,
  blue: colours.blue_100
};

Tag.propTypes = {
  /**
   * Color value for the Tag.
   */
  color: PropTypes.string,
  children: PropTypes.node
};

export default Tag;
